import { CONTACT } from "@/data/site";
import { C, PAGE, fmtLakh, inr, label, newBrandedDoc } from "./pdfKit";

export { fmtLakh };

export const downloadEstimatePdf = async ({ area, finish, extras, low, high, perSqft }) => {
  const doc = await newBrandedDoc("Prepared");
  const { M, R } = PAGE;
  const ref = `CA-${new Date().toISOString().slice(2, 10).replace(/-/g, "")}-${String(area).padStart(4, "0")}`;
  const date = new Date().toLocaleDateString("en-IN", { day: "2-digit", month: "long", year: "numeric" });

  label(doc, "RENOVATION COST ESTIMATE", M, 52);
  doc.setFont("Cormorant", "normal"); doc.setFontSize(30); doc.setTextColor(C.INK);
  doc.text("A rough budget for your home.", M, 63);
  doc.setFont("Plex", "normal"); doc.setFontSize(7.5); doc.setTextColor(C.MUTED);
  doc.text(`Ref ${ref}   ·   ${date}`, M, 70);

  const cy = 78, ch = 46;
  doc.setFillColor(C.INK); doc.rect(M, cy, R - M, ch, "F");
  label(doc, "ROUGH BUDGET", M + 8, cy + 10, C.GOLD);
  doc.setFont("Cormorant", "normal"); doc.setFontSize(34); doc.setTextColor(C.PAPER);
  doc.text(`${fmtLakh(low)}  —  ${fmtLakh(high)}`, M + 8, cy + 26);
  doc.setFont("Plex", "normal"); doc.setFontSize(8); doc.setTextColor("#a8a29e");
  doc.text(`${inr(perSqft[0])} – ${inr(perSqft[1])} per sq ft   ·   ${area.toLocaleString("en-IN")} sq ft built-up`, M + 8, cy + 36);
  [["Finish", finish.label], ["Add-ons", extras.length ? extras.map((e) => e.label).join(", ") : "None"]].forEach(([k, v], i) => {
    const yy = cy + 12 + i * 14;
    label(doc, k.toUpperCase(), R - 8, yy, "#a8a29e", "right");
    doc.setFont("Jakarta", "bold"); doc.setFontSize(9); doc.setTextColor(C.PAPER); doc.text(doc.splitTextToSize(v, 60), R - 8, yy + 5, { align: "right" });
  });

  let y = cy + ch + 14;
  label(doc, "HOW THIS ADDS UP", M, y); y += 6;
  const cols = [M, 108, 138, 168, R];
  doc.setFont("Plex", "normal"); doc.setFontSize(6.5); doc.setTextColor(C.MUTED);
  ["Scope", "Rate low", "Rate high", "Low total", "High total"].forEach((h, i) => doc.text(h.toUpperCase(), cols[i], y, { align: i ? "right" : "left" }));
  y += 2; doc.setDrawColor(C.INK); doc.setLineWidth(0.4); doc.line(M, y, R, y); y += 6;
  [[`${finish.label} finish`, finish.text, finish.rate], ...extras.map((e) => [e.label, e.text, e.rate])].forEach(([lbl, text, rate]) => {
    doc.setFont("Jakarta", "bold"); doc.setFontSize(9); doc.setTextColor(C.INK); doc.text(lbl, M, y);
    doc.setFont("Jakarta", "normal"); doc.setFontSize(7.5); doc.setTextColor(C.MUTED);
    const lines = doc.splitTextToSize(text, 80); doc.text(lines, M, y + 4.2);
    doc.setFont("Plex", "normal"); doc.setFontSize(8); doc.setTextColor(C.INK);
    [inr(rate[0]), inr(rate[1]), fmtLakh((rate[0] * area) / 1e5), fmtLakh((rate[1] * area) / 1e5)].forEach((v, i) => doc.text(v, cols[i + 1], y, { align: "right" }));
    y += 6 + lines.length * 3.6; doc.setDrawColor(C.RULE); doc.setLineWidth(0.25); doc.line(M, y, R, y); y += 6;
  });
  doc.setFont("Jakarta", "bold"); doc.setFontSize(9); doc.setTextColor(C.INK); doc.text("Estimated range", M, y);
  doc.setFont("Plex", "normal"); doc.setFontSize(9);
  [inr(perSqft[0]), inr(perSqft[1]), fmtLakh(low), fmtLakh(high)].forEach((v, i) => doc.text(v, cols[i + 1], y, { align: "right" }));

  y += 16;
  const colW = (R - M - 10) / 2;
  const block = (x, title, body) => {
    label(doc, title, x, y);
    doc.setFont("Jakarta", "normal"); doc.setFontSize(8.5); doc.setTextColor(C.INK);
    doc.text(doc.splitTextToSize(body, colW), x, y + 6, { lineHeightFactor: 1.5 });
  };
  block(M, "GOOD TO KNOW", "This range is indicative for Kerala and excludes land, statutory approvals and GST. Material choices, site access and the condition of the existing structure can move the final number in either direction.");
  block(M + colW + 10, "NEXT STEP", `Share this estimate with your family, then message us on WhatsApp at ${CONTACT.phoneDisplay} or email ${CONTACT.email}. A site visit in Kannur / Thalassery lets us turn this into a proper quotation with drawings.`);

  doc.save(`Carvings-Renovation-Estimate-${area}sqft.pdf`);
};
